'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.update = exports.info = exports.error = exports.warn = exports.success = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactToastify = require('react-toastify');

var _constants = require('../constants');

var toastWrapper = function toastWrapper(type, message, options) {
  return _reactToastify.toast[type](message, _extends({
    position: _reactToastify.toast.POSITION.TOP_RIGHT,
    autoClose: _constants.NOTIFICATION_DEFAULT_CLOSE_TIME,
    className: 'toast ' + type
  }, options));
};

var success = exports.success = function success(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return toastWrapper('success', message, options);
};

var warn = exports.warn = function warn(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return toastWrapper('warn', message, options);
};

var error = exports.error = function error(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return toastWrapper('error', message, options);
};

var info = exports.info = function info(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return toastWrapper('info', message, options);
};

var update = exports.update = function update(notificationId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var toastOptions = _extends({
    autoClose: _constants.NOTIFICATION_DEFAULT_CLOSE_TIME
  }, options);
  // Set the class if type is updating.
  if (toastOptions.type) {
    toastOptions.className = 'toast ' + toastOptions.type;
  }
  _reactToastify.toast.update(notificationId, toastOptions);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/notifications.js
// module id = 448
// module chunks = 0